import api from '../api';

const path = '/rent';

export const addRentRequest = (values) => api.post(`${path}/add`, values);
export const deleteRentRequest = (id) => api.delete(`${path}/delete/${id}`);
export const getRentRequest = (id) => api.get(`${path}/get/${id}`);
export const getRentListRequest = (params) =>
    api.get(`${path}/get`, { params });
export const editRentRequest = (updates) =>
    api.put(`${path}/edit/${updates.id}`, {
        updates,
    });
export const updateRentRequest = (updates) =>
    api.put(`${path}/update/${updates.id}`, updates);
